import Footer from "@/Company/About/Footer";
import PropTypes from "prop-types";
import { cn } from '@/lib/utils';

const DarkFooter = ({ className = "" }) => {
  return (
    <div className={cn("w-full", className)}>
      <Footer />
    </div>
  );
};

DarkFooter.propTypes = {
  className: PropTypes.string,
};

export default DarkFooter;
